import { TTranslator } from '@smartshell/ui-kit';
import day from 'dayjs';

import { TLocalesKeys } from 'localization';

export const formatDate = (date: string | undefined): string =>
  typeof date !== 'undefined' ? day(date).format('D MMM YYYY, HH:mm') : '—';

export const getFormattedDuration = (
  start: string,
  finish: string,
  t: TTranslator<TLocalesKeys>
): string => {
  const startDate = day(start);
  const finishDate = day(finish);

  const hours = finishDate.diff(startDate, 'hours');
  const minutes = finishDate.add(-hours, 'hours').diff(startDate, 'minutes');

  return `${hours} ${t('time.contracted.hours')} ${minutes} ${t(
    'time.contracted.minutes'
  )}`;
};
